"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _creatApp = require("@/api/creatApp");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    appId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      rules: {
        appName: [{
          required: true,
          message: '请输入app名称',
          trigger: 'blur'
        }],
        appUrl: [{
          required: true,
          message: '请上传app图标',
          trigger: 'change'
        }],
        startUrl: [{
          required: true,
          message: '请上传启动页图片',
          trigger: 'change'
        }],
        agreement: [{
          required: true,
          message: '请输入协议URL地址',
          trigger: 'blur'
        }],
        policy: [{
          required: true,
          message: '请输入政策URL地址',
          trigger: 'blur'
        }]
      },
      ruleForm: {
        appName: '',
        firstColor: '',
        secondColor: '',
        policy: '',
        agreement: '',
        appUrl: '',
        startUrl: ''
      },
      appUrlList: [],
      startUrlList: []
    };
  },
  computed: {},
  watch: {},
  mounted: function mounted() {
    var _this = this;
    if (this.appId !== 0) {
      (0, _creatApp.getConfig)({
        appId: this.appId
      }).then(function (res) {
        _this.ruleForm.appName = res.data.name;
        _this.ruleForm.firstColor = res.data.mainColor;
        _this.ruleForm.secondColor = res.data.salveColor;
        _this.ruleForm.agreement = res.data.license;
        _this.ruleForm.policy = res.data.privacy;
        _this.ruleForm.appUrl = res.data.icon;
        _this.ruleForm.startUrl = res.data.bootstrapImage;
        _this.appUrlList = [{
          url: res.data.icon
        }];
        if (res.data.bootstrapImage) {
          _this.startUrlList = [{
            url: res.data.bootstrapImage
          }];
        }
      });
    }
  },
  methods: {
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm[val] = pictureUrl;
              // if (val === 'appUrl') {
              //   this.appUrlList = [{ url: pictureUrl }]
              // } else if (val === 'startUrl') {
              //   this.startUrlList = [{ url: pictureUrl }]
              // }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleRemove: function handleRemove(fileList, val) {
      this.ruleForm[val] = '';
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var buff = _this2.appId === 0 ? _creatApp.saveConfig : _creatApp.updateConfig;
          buff({
            appId: _this2.appId,
            name: _this2.ruleForm.appName,
            mainColor: _this2.ruleForm.firstColor,
            salveColor: _this2.ruleForm.secondColor,
            icon: _this2.ruleForm.appUrl,
            bootstrapImage: _this2.ruleForm.startUrl,
            license: _this2.ruleForm.agreement,
            privacy: _this2.ruleForm.policy,
            administratorList: [1]
          }).then(function (res) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            if (_this2.appId === 0) {
              _this2.$emit('change-value', res.data);
              _this2.$router.replace({
                path: '/systemAdministrator/creatApp/appDetail',
                query: {
                  id: "".concat(res.data)
                }
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};